import { render } from "./ChangePasswordPage.vue?vue&type=template&id=2a150332&ts=true"
import script from "./ChangePasswordPage.vue?vue&type=script&lang=ts"
export * from "./ChangePasswordPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Settings/ChangePasswordPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2a150332"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2a150332', __exports__)) {
    api.reload('2a150332', __exports__)
  }
  
  module.hot.accept("./ChangePasswordPage.vue?vue&type=template&id=2a150332&ts=true", () => {
    api.rerender('2a150332', render)
  })

}


export default __exports__